import React from "react";

import { getCarSetting, updateCar } from "../../model/car";
import ReactSimpleRange from "react-simple-range";
import { formatPrice } from "../common/common";
import { commonErr } from "../common/errors";
import { LoadingInline, LoadingOverlay } from "../common/loading";
import { MessageBox, MessageLine } from "../common/messagebox";

export default class CarSettingDelivery extends React.Component {
	constructor() {
		super();
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			updateErrMsg: "",
		};
	}

	init(car) {
		getCarSetting({ carId: car.id }).then((carSettingResp) => {
			const setting = carSettingResp.data.data;
			if (setting) {
				this.setState({
					err: carSettingResp.data.error,
					errMsg: carSettingResp.data.errorMessage,

					isDelivery: car.deliveryEnable === 1,
					deliveryRadius: car.deliveryRadius,
					deliveryRadiusFree: car.deliveryRadiusFree,
					deliveryPrice: car.deliveryPrice,

					car,
					setting,
				});
			} else {
				this.setState({
					err: carSettingResp.data.error,
					errMsg: carSettingResp.data.errorMessage,
				});
			}
		});
	}

	componentDidMount() {
		const car = this.props.car;
		this.init(car);
	}

	componentWillReceiveProps(props) {
		const car = props.car;
		this.init(car);
	}

	toggleDelivery() {
		this.setState({
			isDelivery: !this.state.isDelivery,
		});
	}

	onDeliveryRadiusChange(range) {
		this.setState({
			deliveryRadius: range.value,
		});
	}

	onDeliveryRadiusFreeChange(range) {
		this.setState({
			deliveryRadiusFree: range.value,
		});
	}

	onDeliveryPriceRangeChange(range) {
		this.setState({
			deliveryPrice: range.value,
		});
	}

	hideMessageBox() {
		this.setState({
			updateErrMsg: "",
		});
	}

	updateCarInfo() {
		const deliveryEnable = this.state.isDelivery;
		const deliveryRadius = this.state.deliveryRadius;
		const deliveryPrice = this.state.deliveryPrice;
		const deliveryRadiusFree = this.state.deliveryRadiusFree;

		this.setState({
			err: commonErr.LOADING,
		});
		updateCar(this.state.car.id, {
			deliveryEnable: deliveryEnable,
			deliveryRadius: deliveryRadius,
			deliveryRadiusFree: deliveryRadiusFree,
			deliveryPrice: deliveryPrice,
		}).then((updateCarResp) => {
			this.setState({
				err: updateCarResp.data.error,
				updateErrMsg: updateCarResp.data.errorMessage,
			});
		});
	}

	render() {
		var content;
		if (this.state.err === commonErr.INNIT) {
			content = <LoadingInline />;
		} else if (!this.state.car || !this.state.setting) {
			content = <MessageLine message="Không tìm thấy thông tin." />;
		} else {
			content = (
				<div className="content">
					{this.state.err === commonErr.LOADING && <LoadingOverlay />}
					{this.state.updateErrMsg && this.state.updateErrMsg !== "" && (
						<MessageBox
							error={this.state.err}
							message={this.state.updateErrMsg}
							show={this.state.updateErrMsg && this.state.updateErrMsg !== ""}
							hideModal={this.hideMessageBox.bind(this)}
						/>
					)}
					<div className="content-container">
						<div className="form-default">
							<h3 className="title">Giao xe tận nơi</h3>
							<p className="position-relative pos-1">
								<div className="switch-on-off" style={{ right: "0", position: "absolute", bottom: "10px" }}>
									<input
										className="switch-input"
										id="cb-instant-delivery"
										type="checkbox"
										checked={this.state.isDelivery}
										onClick={this.toggleDelivery.bind(this)}
									/>
									<label className="switch-label" for="cb-instant-delivery"></label>
								</div>
							</p>

							{this.state.isDelivery && (
								<div className="col-1">
									<div className="line-form end">
										<label className="label">Giao nhận tận nơi trong vòng</label>
										<div className="range-slider">
											<ReactSimpleRange
												step={10}
												min={this.state.setting.deliveryRadiusMin}
												max={this.state.setting.deliveryRadiusMax}
												value={this.state.deliveryRadius}
												sliderSize={14}
												thumbSize={16}
												label={false}
												trackColor={"#5fcf86"}
												thumbColor={"#141414"}
												onChange={this.onDeliveryRadiusChange.bind(this)}
											/>
										</div>
										<span style={{ float: "right", fontSize: "14px" }}>{`${this.state.deliveryRadius}km`}</span>
										<div className="space m" />
										<p className="pl">
											<span className="note">
												Quãng đường đề xuất: {`${this.state.setting.deliveryRadiusRecommend}km`}
											</span>
										</p>
									</div>
								</div>
							)}

							{this.state.isDelivery && (
								<div className="col-2">
									<div className="line-form end">
										<label className="label">Phí giao nhận xe ( 2 chiều )</label>
										<div className="range-slider">
											<ReactSimpleRange
												step={5000}
												min={0}
												max={this.state.setting.deliveryPriceMax}
												value={this.state.deliveryPrice}
												sliderSize={14}
												thumbSize={16}
												label={false}
												trackColor={"#5fcf86"}
												thumbColor={"#141414"}
												onChange={this.onDeliveryPriceRangeChange.bind(this)}
											/>
										</div>
										<span style={{ float: "right", fontSize: "14px" }}>{`${
											this.state.deliveryPrice > 0 ? `${formatPrice(this.state.deliveryPrice)}` : "Miễn phí"
										}`}</span>
										<div className="space m" />
										<p className="pl">
											<span className="note">
												Phí đề xuất: {formatPrice(this.state.setting.deliveryPriceRecommend)}
											</span>
										</p>
									</div>
								</div>
							)}

							{this.state.isDelivery && this.state.deliveryPrice > 0 && (
								<div className="col-1">
									<div className="line-form end">
										<label className="label">Miễn phí giao nhận xe trong vòng</label>
										<div className="range-slider">
											<ReactSimpleRange
												step={10}
												min={this.state.setting.deliveryRadiusFreeMin}
												max={this.state.setting.deliveryRadiusFreeMax}
												value={this.state.deliveryRadiusFree}
												sliderSize={14}
												thumbSize={16}
												label={false}
												trackColor={"#5fcf86"}
												thumbColor={"#141414"}
												onChange={this.onDeliveryRadiusFreeChange.bind(this)}
											/>
										</div>
										<span style={{ float: "right", fontSize: "14px" }}>{`${this.state.deliveryRadiusFree}km`}</span>
										<div className="space m" />
										<p className="pl">
											<span className="note">
												Quãng đường đề xuất: {`${this.state.setting.deliveryRadiusFreeRecommend}km`}
											</span>
										</p>
									</div>
								</div>
							)}

							<div className="space m clear"></div>
						</div>
						{/* <div className="space m"></div> */}
						<div className="line"></div>
						<a className="btn btn-primary btn--m" onClick={this.updateCarInfo.bind(this)}>
							Lưu thay đổi
						</a>
					</div>
				</div>
			);
		}
		return content;
	}
}
